module.exports = __webpack_public_path__ + "static/logo-8e737a7d095898d1b07d0c8cc2f25ba8.png";